import dynaForms from '@elab/core/utils/dynaForms';

const getSelectors = storeName => {
    const dynaSelectors = dynaForms.getSelectors(storeName);
    const getData = state => dynaSelectors.getData(state);
    const getLocalData = state => state[storeName] || {};
    const getPhoneNumber = state => getData(state).mobileNumber.value;
    const getUpdatePhoneNumberForm = state => state[storeName];
    const getUserProfile = state => {
        const data = state[storeName].profile;
        return data;
    };
    const isCheckoutFlow = state => getLocalData(state).isCheckoutFlow;
    const getDataPayload = state => getLocalData(state).dataPayload;
    const getFailedUrl = state => getDataPayload(state).getFailedUrl;
    const getShowSuccessMsg = state => getLocalData(state).showSuccessMsg;
    const getUseAsPopup = state => getLocalData(state).useAsPopup || false;
    const getUpdatePhonePopupEnabled = state =>
        getLocalData(state).updatePhonePopupEnabled || false;
    return {
        ...dynaSelectors,
        getPhoneNumber,
        getUpdatePhoneNumberForm,
        getUserProfile,
        isCheckoutFlow,
        getDataPayload,
        getFailedUrl,
        getShowSuccessMsg,
        getUseAsPopup,
        getUpdatePhonePopupEnabled,
    };
};

export default getSelectors;
